import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "reactstrap";
import { motion } from "framer-motion";
import PressureWshImg from "../assets/images/Power-Washing-Beginner.png";

const Services = () => {
  return (
    <motion.div
      className="container"
      id="serviceheader"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Row>
        <Col>
          <h2>Residential Pressure Washing</h2>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col className="text-center order-md-2" md={7}>
          <img className="img-thumbnail" src={PressureWshImg} />
          <Button className="btn-lg mt-3">Click to ask me</Button>
        </Col>
        <Col className="pt-3 order-md-1" md={5}>
          <h4>Need some cleaning done?</h4>
          <h6>Get the right cleaning done with pressure washing services</h6>
          <br />
          <p>
            Dirt, mold, and mildew can build up on your home's siding and
            surfaces. With the right chemicals and equipment, a simple cleaning
            can help turn your home to looking brand new.
          </p>
          <p> With different methods I can clean:</p>
          <ul>
            <li>Brick</li>
            <li>Concrete</li>
            <li>Composite Wood</li>
            <li>Stucco</li>
            <li>Stone</li>
            <li>Vinyl</li>
          </ul>
          <p>
            I can also do walkways, driveways and patios with similar materials.
            Unfortunately at this time I am unable to clean asphalt.
          </p>
        </Col>
      </Row>
    </motion.div>
  );
};
export default Services;
